import { Show } from "solid-js";
import { rankOf } from "../game/ranks";
import { t } from "../strings";

// The mark of a place on the leaderboard (design 14 §6.5): the same small badge after a player's name everywhere.
export function Flair(props: { f?: string }) {
  return (
    <Show when={props.f}>
      {(f) => <span class={`flair flair-${f()}`}>{t.flairs[f()]}</span>}
    </Show>
  );
}

/** A rating in hundredths as shown: a whole number, with "?" while provisional (design 14 §6.4). */
export const ratingText = (x100: number, provisional?: boolean) => `${Math.round(x100 / 100).toLocaleString()}${provisional ? "?" : ""}`;

/** A change of rating in hundredths, signed. */
export const changeText = (x100: number) => {
  const whole = Math.round(x100 / 100);
  return whole > 0 ? `+${whole}` : `${whole}`;
};

// A rating's rank (design 15 §16.1 step 21): its band's kanji in the display face, the English beside it unless `short`.
export function Rank(props: { x100: number; short?: boolean }) {
  const r = () => t.ranks[rankOf(props.x100)]!;
  return (
    <span class={`rank rank-${rankOf(props.x100)}`} title={`${r().name}: ${t.rankRange[rankOf(props.x100)]}`}>
      <span class="rank-kanji" lang="ja">
        {r().kanji}
      </span>
      {props.short ? null : <span class="rank-name">{r().name}</span>}
    </span>
  );
}
